<button [nbPopover]="remainingRef" class="nrk-button">remaining</button>

<ng-template #remainingRef>

<div class="container">
  <h4>Create new {{typeName}}(s)</h4>
  <table class="nrk-table">
    <tr>
      <th></th>
      <th>Product</th>
      <th>Pieces</th>
      <th>Price</th>
      <th>Date of delivery</th>
    </tr>
    <tr *ngFor="let item of compilation.lineItems; index as idx">
      <td>
        <input type="checkbox" [(ngModel)]="checked[idx]" />
      </td>
      <td>{{item.finishedProduct.calcName}}</td>
      <td>{{item.quantity}}</td>
      <td>{{item.piecePrice | currency : 'EUR' : 'symbol' : '1.3-3' : 'de' }}</td>
      <td>{{item.dateOfDelivery | date : 'YYYY-MM-dd'}}</td>
    </tr>
  </table>
  <div><button class="btn btn-info btn-lg"  (click)="create()">Create 1 {{typeName}} out of selection</button></div>
  <div><button class="btn btn-info btn-lg"  (click)="split(true)">Create 1 {{typeName}} for each selected line item</button></div>
  <div><button class="btn btn-info btn-lg"  (click)="split()">Create 1 {{typeName}} for each line item</button></div>
</div>
</ng-template>
